import React, { useEffect, useContext, useMemo, useState } from 'react';
import { Box, CircularProgress, Grid, Paper, TextField, MenuItem, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, Typography, Autocomplete, Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import { InputAdornment } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import CollapseComponent from '../../components/Schedule/CollapseComponent';
import moment from 'moment/moment';
import Error from '../../components/Error/Error'
import ApiService from '../../functions/apiService';
import { useSnackbar } from 'notistack';
import ManagementHeaderNav from '../../components/HeadersNav/ManagementHeaderNav';
import PaginationComponent from '../../components/Pagination/Pagination';
import StatusInTable from '../../components/StatusInTable/StatusInTable';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { setDetailsSelectedEmp } from '../../store/detailsReducer';
// import EmptyState from '../../components/Error/EmptyState';
import { Col, Row } from 'react-bootstrap';
import '../Calendar/calendar.css'
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ControlPointDuplicateIcon from "@mui/icons-material/ControlPointDuplicate";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from "../../context/AuthContext";
import { toast } from 'react-toastify';
import Multiselect from 'multiselect-react-dropdown';
import { Checkbox } from "@mui/material";
const ReqComponent = () => <span className='text-danger '>*</span>

const formatDate = (dateObj) => {
  var days = { 'Sun': 'Sunday', 'Mon': 'Monday', 'Tue': 'Tuesday', 'Wed': 'Wednesday', 'Thu': 'Thursday', 'Fri': 'Friday', 'Sat': 'Saturday' };
  var months = {
    'Jan': "January", 'Feb': "February", 'Mar': "March", 'Apr': "April", 'May': "May", 'Jun': "June", 'Jul': "July",
    'Aug': "August", 'Sep': "September", 'Oct': "October", 'Nov': "November", 'Dec': "December"
  };
  let day = String(dateObj.getDate())
  let formattedDay = day
  let dateStr = String(dateObj)
  const dateStrArr = dateStr.split(' ')
  if (day.endsWith('1') && day !== '11' && day !== '21' && day !== '31') {
    formattedDay += 'st'
  } else if (day.endsWith('2') && day !== '12' && day !== '22') {
    formattedDay += 'nd'
  } else if (day.endsWith('3') && day !== '13' && day !== '23') {
    formattedDay += 'rd'
  } else {
    formattedDay += 'th'
  }
  return `${days[dateStrArr[0]]} ${formattedDay} ${months[dateStrArr[1]]} ${dateStrArr[3]}`
}


const Textarea = ({ value, onChange, placeholder, disabled = false }) => {
  return (
    <textarea
      disabled={disabled}
      className="form-control"
      rows="2"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      style={{
        width: '100% !important',
        padding: '12px',
        borderRadius: '8px',
        border: '1px solid #CCC',
        resize: 'none',
        boxShadow: '0px 1px 1px  #888888',
      }}
    >
    </textarea>
  )
}

const FilterRows = ({ date, rows, columns, rowSelectionModel, onRowSelectionModelChange, isHistory = false, open, onExpandChange, allowedVars }) => {

  const newRows = useMemo(() => {

    return rows?.data
      ?.filter(row =>
        moment(row.Shift_Date).format("YYYY-MM-DD") === moment(date).format("YYYY-MM-DD")
      )
      .map(row => {
        const formatted = new Date(row.Create_Time)
        let hourMinSec = row.Create_Time?.split(' ')[1]
        let ts = `${formatted.getDate()}/${formatted.getMonth() + 1} ${hourMinSec}`
        return { ...row, timeStamp: ts }
      });

  }, [rows, date]);

  return (
    <CollapseComponent
      key={date}
      rows={newRows}
      columns={columns}
      name={moment(date).format('dddd Do MMMM YYYY')}
      // checkboxSelection={true}
      checkboxSelection={isHistory && (allowedVars?.DETAIL_EDIT_HISTORY === "true") ? true : isHistory === true ? false : true}
      rowSelectionModel={rowSelectionModel}
      onRowSelectionModelChange={onRowSelectionModelChange}
      open={open}
      onExpandChange={onExpandChange}
    />
  )
}

export default function Details() {
  const [loading, setLoading] = useState(true);
  const [Hloading, setHLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [keepHours, setKeepHours] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isDuplicating, setIsDuplicating] = useState(false);
  const [duplicateInitialSig, setDuplicateInitialSig] = useState('');
  const [cansubmit, setCanSubmit] = useState(false);
  const [activeTab, setActiveTab] = useState('upcoming')
  const { user, pages, v3Data } = useContext(AuthContext);

  const [mode, setMode] = useState('manual')
  const [fillMethod, setFillMethod] = useState('auto')

  const [rows, setRows] = useState([])
  const [dates, setDates] = useState([])
  const [historyRows, setHistoryRows] = useState([])
  const [historyDates, setHistoryDates] = useState([])
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  //Form dd state
  const [chosenShift, setChosenShift] = useState(0)
  const [chosenOV, setChosenOV] = useState('')
  const [chosenDetail, setChosenDetail] = useState('')
  const [chosenAssignment, setChosenAssignment] = useState('')
  const [chosenVendor, setChosenVendor] = useState('')
  const [chosenRank, setChosenRank] = useState('')
  const [chosenEMT, setChosenEMT] = useState('')
  const [chosenEmployee, setChosenEmployee] = useState([])
  const [chosenTemplate, setChosenTemplate] = useState('')

  //Form other inputs state
  const [date, setDate] = useState(new Date())
  const [daysNumber, setDaysNumber] = useState(1)
  const [detailsNumber, setDetailsNumber] = useState(1)
  const [startTime, setStartTime] = useState(null)
  const [endTime, setEndTime] = useState(null)
  const [isErrorTime, setIsErrorTime] = useState(false)
  const [detailsText, setDetailsText] = useState('')
  const [assignmentText, setAssignmentText] = useState('')
  const [vendorText, setVendorText] = useState('')

  //Dropdowns lists
  const [shiftList, setShiftList] = useState([])
  const [ovTList, setOvTList] = useState([])
  const [detailsList, setDetailsList] = useState([])
  const [assignmentList, setAssignmentList] = useState([])
  const [vendorList, setVendorList] = useState([])
  const [rankList, setRankList] = useState([])
  const [EMTList, setEMTList] = useState([])
  const [employeesList, setEmployeesList] = useState([])
  const [templateList, setTemplateList] = useState([])

  //ToEdit row
  const [toEdit, setToEdit] = useState({})
  const [dateEdit, setDateEdit] = useState(null)
  const [dateEditTemp, setDateEditTemp] = useState(null)


  const [startTimeEdit, setStartTimeEdit] = useState(null)
  const [endTimeEdit, setEndTimeEdit] = useState(null)
  const [isErrorTimeEdit, setIsErrorTimeEdit] = useState(false)
  const [detailsTextEdit, setDetailsTextEdit] = useState('')
  const [assignmentTextEdit, setAssignmentTextEdit] = useState('')
  const [vendorTextEdit, setVendorTextEdit] = useState('')
  const [chosenShiftEdit, setChosenShiftEdit] = useState(0)
  const [chosenOVEdit, setChosenOVEdit] = useState('')
  const [chosenDetailEdit, setChosenDetailEdit] = useState('')
  const [chosenAssignmentEdit, setChosenAssignmentEdit] = useState('')
  const [chosenVendorEdit, setChosenVendorEdit] = useState('')
  const [chosenRankEdit, setChosenRankEdit] = useState('')
  const [chosenEmployeeEdit, setChosenEmployeeEdit] = useState([])
  const [chosenEMTEdit, setChosenEMTEdit] = useState('')
  const [expandAll, setExpandAll] = useState(true);
  const [anyExpanded, setAnyExpanded] = useState(true);
  const [fillMethodEdit, setFillMethodEdit] = useState('auto');
  const [origFillMethodEdit, setOrigFillMethodEdit] = useState('auto');
  const [keepHoursEdit, setKeepHoursEdit] = useState(false);
  const [allowedVars, setAllowedVars] = useState({});
  const defaultKeepHours = allowedVars?.V3_AUTO_CHECKED_KEEP_HOURS_CHECKBOX == "true";

  useEffect(() => {
    setKeepHours(defaultKeepHours);
    setKeepHoursEdit(defaultKeepHours);
  }, [defaultKeepHours]);
const [selectedEmployees, setSelectedEmployees] = useState([])
const [doNotMarkHours, setDoNotMarkHours] = useState(false);
  const toggleAllCollapses = () => {
    setExpandAll(prev => !prev);
    if (!expandAll) {
      setAnyExpanded(true);
    }
    else {
      setAnyExpanded(false);
    }
  };

  const handleExpandChange = (isExpanded) => {
    if (isExpanded) {
      setAnyExpanded(true);
    }
    else {
      setAnyExpanded(false);
    }
  };

  let getAllowedVars = () => {
    ApiService.get('/v3Variables')
      .then((res) => {
        setAllowedVars(res?.data?.data)
      }).catch(({ error }) => {
        console.error('error', error)
      });
  }

  useEffect(() => {
    getAllowedVars();
  }, [])


  const dispatch = useDispatch()
  const SelectedEmp = useSelector((state) => state.detailsReducer.SelectedEmp)
  let onRowSelectionModelChange = (newSelection) => {
    dispatch(setDetailsSelectedEmp(newSelection))
  }

  useEffect(() => {
    if (date, daysNumber, chosenVendor) {
      if (mode == 'manual') {
        if (detailsNumber && chosenOV && chosenDetail && chosenAssignment) {
          setCanSubmit(true)
        }
        if (chosenShift === 0) {
          if (!startTime || !endTime) {
            setCanSubmit(false)
          }
        }
      } else {
        if (chosenTemplate && chosenOV) {
          setCanSubmit(true)
        }
      }
    }
    if (detailsNumber < 1) {
      setCanSubmit(false)
    }
    if (fillMethod === 'manual') {
      if (selectedEmployees.length < 1) {
        setCanSubmit(false);
      }
    }

    // if (fillMethod === 'manual' && daysNumber > 1) {
    //   setDaysNumber(1);
    //   toast.warning("Warning: manual assign is limited to one day");
    // }
  })

  useEffect(() => {
    if (SelectedEmp.length === 1) {
      const id = SelectedEmp[0];

      const upcomingMatch = rows?.data?.find(r => r.id === id);
      const historyMatch = historyRows?.data?.find(r => r.id === id);

      setToEdit(upcomingMatch || historyMatch || null);
    }
  }, [SelectedEmp, rows, historyRows]);

  useEffect(() => {
    if (fillMethod === 'manual' && selectedEmployees.length > 0) {
      setDetailsNumber(selectedEmployees.length);
    }
  }, [selectedEmployees, fillMethod]);

  useEffect(() => {
    if (toEdit) {
      const d = moment(toEdit.Shift_Date).toDate()
      setDateEdit(d)
      setDateEditTemp(d)
      setChosenShiftEdit(toEdit.Shift_Code)
      if (toEdit.Shift_Code === 0) {
        const s = new Date(`2024-12-12 ${toEdit.Start_Time}`)
        const e = new Date(`2024-12-12 ${toEdit.End_Time}`)
        setStartTimeEdit(s)
        setEndTimeEdit(e)
      }
      setChosenOVEdit(toEdit.Overtime_List)
      setChosenDetailEdit(toEdit.Detail_Type)
      setChosenAssignmentEdit(toEdit.Assignment_Code)
      setChosenVendorEdit(toEdit.Vendor_Type)
      setDetailsTextEdit(toEdit.Detail_Text)
      setAssignmentTextEdit(toEdit.Assignment_Text)
      setVendorTextEdit(toEdit.Vendor_Text)
      setChosenRankEdit(toEdit.Rank)
      setChosenEMTEdit(toEdit.EMT)

      if (toEdit.Status === 'F') {
        setFillMethodEdit('manual')
        setOrigFillMethodEdit('manual')
        setChosenEmployeeEdit([toEdit.filledEmpCode])
      } else {
        setFillMethodEdit('auto')
        setOrigFillMethodEdit('auto')
      }
      setKeepHoursEdit(defaultKeepHours)
    }
  }, [toEdit])

  // useEffect(() => {
  //   if (endTimeEdit && startTimeEdit && (startTimeEdit.getTime() >= endTimeEdit.getTime())) {
  //     setIsErrorTimeEdit(true)
  //   } else {
  //     setIsErrorTimeEdit(false)
  //   }
  // }, [startTimeEdit, endTimeEdit])

  const columns = [
    {
      field: 'Time',
      headerName: 'Time',
      flex: 1.1,
      minWidth: 120,
      valueGetter: (params) => {
        if (params.row.ShiftName) {
          return params.row.ShiftName;
        } else {
          const startTime = params.row?.Start_Time || "N/A";
          const endTime = params.row?.End_Time || "N/A";
          return `${varFormatTime(`${startTime}-${endTime}`, user?.Time_Format)}`;
        }
      }
    },
    {
      field: 'Overtime_List',
      headerName: 'List',
      flex: 1,
      minWidth: 90,
      disableColumnMenu: true,
    },
    {
      field: 'StatusText',
      headerName: 'Status',
      flex: 1.6,
      minWidth: 160,
      renderCell: (params) => <StatusInTable StatusText={params.row.StatusText + params.row.filledEmp} StatusColor={params.row.StatusColor} detailspill={true} />
    },
    {
      field: 'Detail_Type',
      headerName: 'Description',
      flex: 1.6,
      minWidth: 160,
      valueGetter: (params) => params.row?.Detail_Text ? params.row?.Detail_Type + ' - ' + params.row?.Detail_Text : params.row?.Detail_Type,
      renderCell: (params) => (
        <div
          style={{
            fontSize: '14px',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: 'VendorName',
      headerName: 'Vendor',
      flex: 1.1,
      minWidth: 110,
      valueGetter: (params) => params.row?.VendorName ? params.row?.VendorName : params.row?.Vendor_Text
    },
    {
      field: 'Rank',
      headerName: 'Rank',
      flex: 0.7,
      minWidth: 70,
      disableColumnMenu: true,
      valueGetter: (params) => params.row?.Rank == '' ? 'Any' : params.row?.Rank
    },
    {
      field: 'EMT',
      headerName: 'EMT',
      flex: 0.7,
      minWidth: 70,
      disableColumnMenu: true,
      valueGetter: (params) => params.row?.EMT == '' ? 'Any' : params.row?.EMT
    },
    {
      field: 'duplicate',
      headerName: '',
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      width: 56,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <IconButton
          size="small"
          title="Duplicate"
          onClick={(e) => {
            e.stopPropagation();
            handleDuplicate(params.row);
          }}
        >
          <ControlPointDuplicateIcon fontSize="small" />
        </IconButton>
      ),
    },
  ];

  // const { enqueueSnackbar } = useSnackbar();

  const loadData = (page = 1) => {
    setLoading(true)
    ApiService.get('/getDetailShifts', { page: page }, 'getDetailShifts').then(({ data }) => {
      setRows(data.data)
      let dates2 = []
      dates2 = data.data.data.map(row => row.Shift_Date)
      dates2 = dates2.filter((row, i) => dates2.indexOf(row) === i)
      setDates(dates2)
      setLoading(false)
    }).catch(() => {
      setLoading(false)
      toast.error("Error")
      // enqueueSnackbar('Error', { variant: 'error' });
    })

  }

  const loadHistoryDate = (page = 1) => {
    setHLoading(true)
    ApiService.get('/getHistoryDetailShifts', { page: page }, 'getHistoryDetailShifts').then(({ data }) => {
      setHLoading(false)
      setHistoryRows(data.data)
      let dates2 = []
      dates2 = data.data.data.map(row => row.Shift_Date)
      dates2 = dates2.filter((row, i) => dates2.indexOf(row) === i)
      setHistoryDates(dates2)
    }).catch(() => {
      setHLoading(false)
      toast.error("Error")
      // enqueueSnackbar('Error', { variant: 'error' });
    })
  }

  const loadDropDowns = () => {
    ApiService.get('/shiftTypes', {}, 'shiftTypes').then(({ data }) => {
      const customObj = {
        "ShiftCode": 0,
        "Shift": "Custom",
      }
      const newList = [...data.data, customObj]
      setShiftList(newList)
    }).catch(() => {
      toast.error("Error")
      // enqueueSnackbar('Error', { variant: 'error' });
    })

    ApiService.get('/getOverTimeListDDL', {}, 'getOverTimeListDDL').then(({ data }) => {
      setChosenOV(data[data.length - 1].Overtime_List)
      setOvTList(data)
    }).catch(() => {
      toast.error("Error")
      // enqueueSnackbar('Error', { variant: 'error' });
    })

    ApiService.get('/getDetailListDDL', {}, 'getDetailListDDL').then(({ data }) => {
      if (data[0]) {
        setChosenDetail(data[0].SO_Value)
      }
      setDetailsList(data)
    }).catch(() => {
      toast.error("Error")
      // enqueueSnackbar('Error', { variant: 'error' });
    })

    ApiService.get('/getAssignmentListDDL', {}, 'getAssignmentListDDL').then(({ data }) => {
      setChosenAssignment('OTHER')
      setAssignmentList([...data, {
        "SO_Value": "OTHER",
        "SO_Desc": "Other",
      }])
    }).catch(() => {
      toast.error("Error")
      // enqueueSnackbar('Error', { variant: 'error' });
    })

    ApiService.get('/getVendorListDDL', {}, 'getVendorListDDL').then(({ data }) => {
      setChosenVendor(Object.entries(data)[0][0]);
      setVendorList(Object.entries(data))
    }).catch(() => {
      toast.error("Error")
      // enqueueSnackbar('Error', { variant: 'error' });
    })

    ApiService.get('/getRankListDDL', {}, 'getRankListDDL').then(({ data }) => {
      setChosenRank('ANY')
      setRankList([...Object.entries(data), ['ANY', 'Any']])
    }).catch(() => {
      toast.error("Error")
      // enqueueSnackbar('Error', { variant: 'error' });
    })

    ApiService.get('/getEMTListDDL', {}, 'getEMTListDDL').then(({ data }) => {
      if (Object.entries(data)[0] && Object.entries(data)[0][0]) {
        setChosenEMT(Object.entries(data)[0][0])
      }
      setEMTList([...Object.entries(data), ['ANY', 'Any']])
    }).catch(() => {
      toast.error("Error")
      // enqueueSnackbar('Error', { variant: 'error' });
    })

    const endpoint = allowedVars.V3_SEQUENTIAL_OFFERS == "true" ? '/getEmployeeDDL?sort=detail-sequential' : '/getEmployeeDDL';

    ApiService.get(endpoint, {}, endpoint).then(({ data }) => {
      const transformedData = data.map(emp => ({
        ...emp,
        displayLabel: emp.EA_Rank ? `${emp.EA_Rank} - ${emp.fullName}` : emp.fullName
      }));
      setEmployeesList(transformedData);
      // setEmployeesList(data)
    }).catch(() => {
      toast.error("Error")
    })

    ApiService.get('/getCrewDTemplatesDDL', {}, 'getCrewDTemplatesDDL').then(({ data }) => {
      setTemplateList(data)
    }).catch(() => {
      toast.error("Error")
      // enqueueSnackbar('Error', { variant: 'error' });
    })
  }

  useEffect(() => {
    loadData()
    loadHistoryDate()
    loadDropDowns()
  }, [allowedVars.V3_SEQUENTIAL_OFFERS])

  // useEffect(() => {
  //   if (endTime && startTime && (startTime.getTime() >= endTime.getTime())) {
  //     setIsErrorTime(true)
  //   } else {
  //     setIsErrorTime(false)
  //   }
  // }, [startTime, endTime])

  const handleSubmit = (e) => {
    e.preventDefault()
    setSaving(true)
    const dateBody = moment(date).format('YYYY-MM-DD')
    let start, end;
    if (startTime) start = startTime.toString().split(' ')[4]
    if (endTime) end = endTime.toString().split(' ')[4]
    const body = {
      "ShiftDate": dateBody,
      "NumberDays": daysNumber,
      "Mode": mode.toUpperCase(),
      "SelTemplate": chosenTemplate,
      "NumberDetails": detailsNumber,
      "ShiftCode": chosenShift,
      "StartTime": chosenShift === 0 ? start : "08:00:00",
      "EndTime": chosenShift === 0 ? end : "17:59:59",
      "OvertimeList": chosenOV,
      "Detail": chosenDetail,
      "DetailText": detailsText,
      "Assignment": chosenAssignment,
      "AssignmentText": assignmentText,
      "SelVendorType": chosenVendor,
      "VendorText": vendorText,
      "FillMethod": fillMethod[0].toUpperCase(),
      "SelRank": chosenRank,
      "DisableMarkingHours":doNotMarkHours,
      "SelEmt": chosenEMT,
      // "selEmp": fillMethod.startsWith('m') ? [chosenEmployee] : []
       "selEmp": fillMethod.startsWith('m') ? selectedEmployees.map(emp => emp.Emp_Code) : []
    }

    ApiService.post('/postDetailShifts', body)
      .then((data) => {
        toast.success(data.message)
        // enqueueSnackbar('success', { variant: 'success' });
        setTimeout(() => {
          window.location.reload(true);
        }, 2000)
        // setSaving(false)
        // loadData()
        // setDate(new Date())
        // setDaysNumber(1)
        // setChosenOV('')
        // setMode('manual')
        // setDetailsNumber(1)
        // setChosenShift(0)
        // setStartTime(null)
        // setEndTime(null)
        // setChosenDetail('')
        // setDetailsText('')
        // setChosenAssignment('')
        // setAssignmentText('')
        // setChosenVendor('')
        // setVendorText('')
        // setFillMethod('auto')
        // setChosenRank('')
        // setChosenEMT('')
        // setChosenEmployee([])
        // window.location.reload();
        // setIsAdding(false)
      }).catch(({ data }) => {
        setSaving(false)
        toast.error(data?.message)
        // enqueueSnackbar('Error', { variant: 'error' });
      })
  }

  // Builds a comparable signature of the Add form values so we can detect
  // whether the user has changed anything after opening the Duplicate modal.
  const buildSig = (v) => JSON.stringify({
    date: v.date ? moment(v.date).format('YYYY-MM-DD') : null,
    daysNumber: v.daysNumber,
    mode: v.mode,
    chosenOV: v.chosenOV,
    detailsNumber: v.detailsNumber,
    chosenShift: v.chosenShift,
    startTime: v.startTime ? moment(v.startTime).format('HH:mm') : null,
    endTime: v.endTime ? moment(v.endTime).format('HH:mm') : null,
    chosenDetail: v.chosenDetail,
    detailsText: v.detailsText,
    chosenAssignment: v.chosenAssignment,
    assignmentText: v.assignmentText,
    chosenVendor: v.chosenVendor,
    vendorText: v.vendorText,
    fillMethod: v.fillMethod,
    chosenRank: v.chosenRank,
    chosenEMT: v.chosenEMT,
    chosenTemplate: v.chosenTemplate,
    selectedEmployees: (v.selectedEmployees || []).map(e => e.Emp_Code).sort(),
  });

  const handleDuplicate = (row) => {
    const d = row?.Shift_Date ? moment(row.Shift_Date).toDate() : new Date();
    let st = null, et = null;
    if (row?.Shift_Code === 0) {
      st = row?.Start_Time ? new Date(`2024-12-12 ${row.Start_Time}`) : null;
      et = row?.End_Time ? new Date(`2024-12-12 ${row.End_Time}`) : null;
    }
    const vals = {
      date: d,
      daysNumber: 1,
      mode: 'manual',
      chosenOV: row?.Overtime_List ?? '',
      detailsNumber: 1,
      chosenShift: row?.Shift_Code ?? 0,
      startTime: st,
      endTime: et,
      chosenDetail: row?.Detail_Type ?? '',
      detailsText: row?.Detail_Text ?? '',
      chosenAssignment: row?.Assignment_Code ?? '',
      assignmentText: row?.Assignment_Text ?? '',
      chosenVendor: row?.Vendor_Type ?? '',
      vendorText: row?.Vendor_Text ?? '',
      fillMethod: 'auto',
      chosenRank: 'ANY',
      chosenEMT: row?.EMT ?? '',
      chosenTemplate: '',
      selectedEmployees: [],
    };

    setDate(vals.date);
    setDaysNumber(vals.daysNumber);
    setMode(vals.mode);
    setChosenOV(vals.chosenOV);
    setDetailsNumber(vals.detailsNumber);
    setChosenShift(vals.chosenShift);
    setStartTime(vals.startTime);
    setEndTime(vals.endTime);
    setChosenDetail(vals.chosenDetail);
    setDetailsText(vals.detailsText);
    setChosenAssignment(vals.chosenAssignment);
    setAssignmentText(vals.assignmentText);
    setChosenVendor(vals.chosenVendor);
    setVendorText(vals.vendorText);
    setFillMethod(vals.fillMethod);
    setChosenRank(vals.chosenRank);
    setChosenEMT(vals.chosenEMT);
    setChosenTemplate(vals.chosenTemplate);
    setSelectedEmployees(vals.selectedEmployees);

    setDuplicateInitialSig(buildSig(vals));
    setIsDuplicating(true);
  };

  const closeDuplicate = () => {
    setIsDuplicating(false);
    setDuplicateInitialSig('');
  };

  const handleSubmitEdit = (e) => {
    e.preventDefault()
    setSaving(true)
    const dateBody = moment(dateEdit).format('YYYY-MM-DD')
    const dateBodyTemp = moment(dateEditTemp).format('YYYY-MM-DD')


    let start, end;
    if (startTimeEdit) start = startTimeEdit.toString().split(' ')[4]
    if (endTimeEdit) end = endTimeEdit.toString().split(' ')[4]
    const body = {
      "ShiftDateTemp": dateBodyTemp,
      "ShiftDate": dateBody,
      "ShiftNumber": toEdit.Shift_Number,
      "ShiftCode": chosenShiftEdit,
      "StartTime": start,
      "EndTime": end,
      "OvertimeList": chosenOVEdit,
      "Detail": chosenDetailEdit,
      "DetailText": detailsTextEdit,
      "Assignment": chosenAssignmentEdit,
      "AssignmentText": assignmentTextEdit,
      "SelVendorType": chosenVendorEdit,
      "VendorText": vendorTextEdit,
      "FillMethod": fillMethodEdit[0].toUpperCase(),
      "SelRank": chosenRank,
      "SelEmt": chosenEMT,
      "selEmp": fillMethodEdit.startsWith('m') ? chosenEmployeeEdit : []
    }
    if (allowedVars?.V3_ALLOW_KEEP_DETAIL_OSL_HOURS === 'true') {
      body.keep_hours = keepHoursEdit ? 1 : 0;
    }
    ApiService.post('/editDetailShifts', body)
      .then((data) => {
        setSaving(false)
        setIsEditing(false)
        dispatch(setDetailsSelectedEmp([]))
        toast.success(data.message)
        window.location.reload();
      }).catch(({ data }) => {
        setSaving(false)
        toast.error(data.message)
      })
  }
  const deleteShifts = () => {
    setSaving(true);

    const toDeleteUpcoming = rows?.data?.filter(r => SelectedEmp.includes(r.id));
    const toDeleteHistory = historyRows?.data?.filter(r => SelectedEmp.includes(r.id));

    const toDelete = [...toDeleteUpcoming, ...toDeleteHistory];

    const keepHoursEnabled = allowedVars?.V3_KEEP_HOURS_DELETE_DETAIL === "true";

    toDelete.forEach((r) => {
      const { Shift_Date, Shift_Number } = r;

      const body = {
        ShiftDate: Shift_Date,
        ShiftNumber: Shift_Number
      };

      if (keepHoursEnabled) {
        body.keep_hours = keepHours ? 1 : 0;
      }

      ApiService.delete('/deleteDetailShift', body)
        .then((data) => {
          toast.success(data.message);
        })
        .catch((error) => {
          toast.error(`Error deleting Shift No. #${Shift_Number} on ${Shift_Date}`);
        });
    });

    setSaving(false);
    setDeleteModal(false);
    setKeepHours(defaultKeepHours);
    dispatch(setDetailsSelectedEmp([]));
    loadData();
    loadHistoryDate();
  };

  const handleDeleteClick = () => {
    if (allowedVars?.V3_KEEP_HOURS_DELETE_DETAIL === "true") {
      setKeepHours(defaultKeepHours);
      setDeleteModal(true);
    } else {
      deleteShifts();
    }
  };


  const PageChanged = (e, page) => {
    loadData(page)
  }

  const PageChangedHistory = (e, page) => {
    loadHistoryDate(page)
  }

  const currentSig = buildSig({
    date, daysNumber, mode, chosenOV, detailsNumber, chosenShift, startTime, endTime,
    chosenDetail, detailsText, chosenAssignment, assignmentText, chosenVendor, vendorText,
    fillMethod, chosenRank, chosenEMT, chosenTemplate, selectedEmployees,
  });
  const duplicateDirty = isDuplicating && currentSig !== duplicateInitialSig;

  return (<>
    {/* <ManagementHeaderNav /> */}
    <Paper className='p-3' style={{ marginTop: "1rem" }}>
      <Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 12 }}>
        {(isAdding || isDuplicating) && (() => {
          const detailFormEl = (
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={3}>
                    <label style={{ fontSize: '14px' }}>Date <ReqComponent /></label>
                    <Box className='mt-1'>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          value={date}
                          onChange={(e) => setDate(e)}
                          sx={{
                            width: "100%",
                            "& .MuiInputBase-root": {
                              height: '48px',
                              fontSize: '14px'
                            },
                          }}
                          disablePast
                          dateInputIcon={<CalendarTodayIcon />}
                        />
                      </LocalizationProvider>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={12} md={3}>
                    <label style={{ fontSize: '14px' }}>For <ReqComponent /></label>
                    <Box className='mt-1'>
                      <TextField
                        className='w-100'
                        variant="outlined"
                        type="number"
                        InputProps={{
                          inputProps: { min: 1 },
                          endAdornment: <InputAdornment position="end">Days</InputAdornment>,
                          sx: {
                            height: '48px',
                            fontSize: '14px'
                          }
                        }}
                        value={daysNumber}
                        onChange={e => setDaysNumber(e.target.value)}
                      >
                      </TextField>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={12} md={3}>
                    <label style={{ fontSize: '14px' }}>Overtime List <ReqComponent /></label>
                    <Box className='mt-1'>
                      <TextField
                        className='w-100' color='secondary' variant="outlined"
                        select
                        value={chosenOV}
                        onChange={e => setChosenOV(e.target.value)}
                        InputProps={{
                          sx: {
                            height: '48px',
                            fontSize: '14px'
                          }
                        }}
                      >
                        {ovTList.map(type => (
                          <MenuItem value={type.Overtime_List}>{type.Overtime_List_Description} </MenuItem>
                        ))}
                      </TextField>
                    </Box>
                  </Grid>
                </Grid>

                <Grid container className='pt-3'>
                  <Grid item xs={12} sm={12} md={6}>
                    <FormControl sx={{ flexDirection: 'row', gap: '16px', alignItems: 'center' }}>
                      <FormLabel className=" text-black " style={{ fontSize: '14px' }}>Mode</FormLabel>
                      <RadioGroup
                        value={mode}
                        onChange={(e) => setMode(e.target.value)}
                        name="radio-buttons-group"
                        row
                      >
                        <FormControlLabel value="manual" control={<Radio />} label="Create Manually" />
                        <FormControlLabel value="template" control={<Radio />} label="Create From Template" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  {allowedVars?.V3_ADD_CHECKBOX_FOR_ADD_DETAIL && <Grid item xs={12} sm={12} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={doNotMarkHours}
                          onChange={(e) => setDoNotMarkHours(e.target.checked)}
                          color="primary"
                        />
                      }
                      label="Do Not Mark Hours"
                    />
                  </Grid>}
                </Grid>
               
               

                {mode === 'manual' &&
                  <>
                    <Grid container spacing={2} className='py-2'>
                      <Grid item xs={12} sm={12} md={3}>
                        <label style={{ fontSize: '14px' }}>{allowedVars.V3_DETAIL_LABEL_MEMBER_MODE && allowedVars.V3_DETAIL_LABEL_MEMBER_MODE ? allowedVars.V3_DETAIL_LABEL_MEMBER_MODE : "Number of Details"}<ReqComponent /></label>
                        <Box className='mt-1'>
                          {/* <TextField
                            className='w-100'
                            variant="outlined"
                            type="number"
                            defaultValue={1}
                            InputProps={{
                              inputProps: { min: 1 },
                              sx: {
                                height: '48px',
                                fontSize: '14px'
                              }
                            }}
                            value={detailsNumber}
                            onChange={e => setDetailsNumber(e.target.value)}
                          >
                          </TextField> */}
                        <TextField
                          className='w-100'
                          variant="outlined"
                          type="number"
                          defaultValue={1}
                          InputProps={{
                            inputProps: { min: 1 },
                            readOnly: fillMethod === 'manual',
                            sx: {
                              height: '48px',
                              fontSize: '14px',
                              ...(fillMethod === 'manual' && {
                                backgroundColor: '#f5f5f5',
                                cursor: 'not-allowed'
                              })
                            }
                          }}
                          value={detailsNumber}
                          onChange={e => setDetailsNumber(e.target.value)}
                        />

                          {/* <TextField
                            className="w-100"
                            variant="outlined"
                            type="number"
                            value={1}
                            InputProps={{
                              readOnly: true,
                              sx: {
                                height: '48px',
                                fontSize: '14px',
                                color: '#9e9e9e',
                                cursor: 'not-allowed',
                                pointerEvents: 'none', 
                              },
                            }}
                          /> */}

                          <Error> {detailsNumber < 1 ? 'Number must be more than 1' : ''} </Error>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={12} md={3}>
                        <label style={{ fontSize: '14px' }}>Shift<ReqComponent /></label>
                        <Box className='mt-1'>
                          <TextField
                            className='w-100' color='secondary' variant="outlined"
                            select
                            value={chosenShift}
                            onChange={e => setChosenShift(e.target.value)}
                            InputProps={{
                              sx: {
                                height: '48px',
                                fontSize: '14px'
                              }
                            }}
                          >
                            {shiftList.map(type => (
                              <MenuItem value={type.ShiftCode}>{type.Shift} </MenuItem>
                            ))}
                          </TextField>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={12} md={2}>
                        {chosenShift === 0 && <label style={{ fontSize: '14px' }}>From <ReqComponent /></label>}
                        <Box className='mt-1'>
                          {chosenShift === 0 &&
                            <>
                              <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <TimePicker
                                  timeSteps={{ minutes: 30 }}
                                  value={startTime}
                                  onChange={(newValue) => setStartTime(newValue)}
                                  sx={{
                                    "& .MuiOutlinedInput-input": { color: isErrorTime && 'red' },
                                    width: "100%",
                                    "& .MuiInputBase-root": {
                                      height: '48px',
                                      fontSize: '14px'
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                            </>
                          }
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={12} md={2}>
                        {chosenShift === 0 && <label style={{ fontSize: '14px' }}>To <ReqComponent /></label>}
                        <Box className='mt-1'>
                          {chosenShift === 0 &&
                            <>
                              <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <TimePicker
                                  timeSteps={{ minutes: 30 }}
                                  value={endTime}
                                  onChange={(newValue) => setEndTime(newValue)}
                                  sx={{
                                    "& .MuiOutlinedInput-input": { color: isErrorTime && 'red' },
                                    width: "100%",
                                    "& .MuiInputBase-root": {
                                      height: '48px',
                                      fontSize: '14px'
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                            </>
                          }
                        </Box>
                      </Grid>

                      {/* {isErrorTime &&
                        <div style={{ position: 'relative', left: '52.5%', color: 'red', fontSize: '.9rem' }}>
                          Error: "To" time must be after "From"
                        </div>
                      } */}
                    </Grid>

                    <Grid container spacing={2} className='pt-2'>
                      <Grid item xs={12} sm={12} md={4}>
                        <div>
                          <label style={{ fontSize: '14px' }}>Details (What)<ReqComponent /></label>
                          <Box className='mt-1'>
                            <TextField
                              className='w-100' color='secondary' variant="outlined"
                              select
                              value={chosenDetail}
                              onChange={e => setChosenDetail(e.target.value)}
                              InputProps={{
                                sx: {
                                  height: '48px',
                                  fontSize: '14px'
                                }
                              }}
                            >
                              {detailsList.map(type => (
                                <MenuItem value={type.SO_Value}>{type.SO_Desc} </MenuItem>
                              ))}
                            </TextField>
                          </Box>
                        </div>
												</Grid>

                      <Grid item xs={12} sm={12} md={4}>
                        <div>
                          <label style={{ fontSize: '14px', paddingLeft: '2px'}}>Details Description</label>
                          <Box className='mt-1'>
                            <Textarea
                              value={detailsText}
                              onChange={e => setDetailsText(e.target.value)}
                              placeholder='Enter details description'
                              minRows={2}
															style={{height: '55px'}}
                            />
                          </Box>
                        </div>
                      </Grid>
										</Grid>

                    <Grid container spacing={2} className='pt-2' style={{marginTop: '2px'}}>
                      <Grid item xs={12} sm={12} md={4}>
                        <div>
                          <label style={{ fontSize: '14px' }}>Assignment (Where)<ReqComponent /></label>
                          <Box className='mt-1'>
                            <TextField
                              className='w-100' color='secondary' variant="outlined"
                              select
                              value={chosenAssignment}
                              onChange={e => setChosenAssignment(e.target.value)}
                              InputProps={{
                                sx: {
                                  height: '48px',
                                  fontSize: '14px'
                                }
                              }}
                            >
                              {assignmentList.map(type => (
                                <MenuItem value={type.SO_Value}>{type.SO_Desc} </MenuItem>
                              ))}
                            </TextField>
                          </Box>
                        </div>
											</Grid>

                      <Grid item xs={12} sm={12} md={4}>
                        <div>
                          <label style={{ fontSize: '14px', paddingLeft: '2px' }}>Assignment Description</label>
                          <Box className='mt-1'>
                            <Textarea
                              disabled={chosenAssignment != 'OTHER'}
                              value={assignmentText}
                              onChange={e => setAssignmentText(e.target.value)}
                              placeholder='Enter assignment description'
                            />
                          </Box>
                        </div>
                      </Grid>
											</Grid>

                    <Grid container spacing={2} className='pt-2' style={{marginTop: '2px'}}>
                      <Grid item xs={12} sm={12} md={4}>
                        <div>
                          <label style={{ fontSize: '14px' }}>Vendor<ReqComponent /></label>
                          <Box className='mt-1'>
                            <TextField
                              className='w-100' color='secondary' variant="outlined"
                              select
                              value={chosenVendor}
                              onChange={e => setChosenVendor(e.target.value)}
                              InputProps={{
                                sx: {
                                  height: '48px',
                                  fontSize: '14px'
                                }
                              }}
                            >
                              {vendorList.map(vendor => (
                                <MenuItem value={vendor[0]}>{vendor[1]} </MenuItem>
                              ))}

                            </TextField>
                          </Box>
                        </div>
												</Grid>

                      <Grid item xs={12} sm={12} md={4}>
                        <div>
                          <label style={{ fontSize: '14px', paddingLeft: '2px' }}>Vendor Description</label>
                          <Box className='mt-1'>
                            <Textarea
                              value={vendorText}
                              onChange={e => setVendorText(e.target.value)}
                              placeholder='Enter vendor info'
                            />
                          </Box>
                        </div>
                      </Grid>
                    </Grid>

                    <Grid item columns={{ xs: 12, sm: 12, md: 12 }} className='pt-3'>
                      <FormControl sx={{ flexDirection: 'row', gap: '16px', alignItems: 'center' }}>
                        <FormLabel className=" text-black " style={{ fontSize: '14px' }}>Fill Type</FormLabel>
                        <RadioGroup
                          value={fillMethod}
                          onChange={(e) => setFillMethod(e.target.value)}
                          name="radio-buttons-group"
                          row
                        >
                          <FormControlLabel value="auto" control={<Radio />} label="Auto" />
                          <FormControlLabel value="manual" control={<Radio />} label="Manual" />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    {fillMethod === 'auto' &&
                      <>
                        <Grid container spacing={2} className='pt-2'>
                          <Grid item xs={12} sm={12} md={3}>
                            <label style={{ fontSize: '14px' }}>Rank <ReqComponent /></label>
                            <Box className='mt-1'>
                              <TextField
                                className='w-100' color='secondary' variant="outlined"
                                select
                                value={chosenRank}
                                onChange={e => setChosenRank(e.target.value)}
                                InputProps={{
                                  sx: {
                                    height: '48px',
                                    fontSize: '14px'
                                  }
                                }}
                              >
                                {rankList.map(r => (
                                  <MenuItem value={r[0]}>{r[1]} </MenuItem>
                                ))}
                              </TextField>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={12} md={3}>
                            <label style={{ fontSize: '14px' }}>EMT <ReqComponent /></label>
                            <Box className='mt-1'>
                              <TextField
                                className='w-100' color='secondary' variant="outlined"
                                select
                                value={chosenEMT}
                                onChange={e => setChosenEMT(e.target.value)}
                                InputProps={{
                                  sx: {
                                    height: '48px',
                                    fontSize: '14px'
                                  }
                                }}
                              >
                                {EMTList.map(e => (
                                  <MenuItem value={e[0]}>{e[1]} </MenuItem>
                                ))}
                              </TextField>
                            </Box>
                          </Grid>
                        </Grid>
                      </>
                    }

                    {fillMethod === 'manual' &&
                      <Grid container spacing={2} className='pt-2'>
                        <Grid item xs={12} sm={12} md={3}>
                          <label style={{ fontSize: '14px' }}>Employees <ReqComponent /></label>
                          {/* <Box className='mt-1'>
                            <Autocomplete
                              className="w-100"
                              value={employeesList.find(emp => emp.Emp_Code === chosenEmployee) || null}
                              onChange={(event, newValue) => {
                                setChosenEmployee(newValue ? newValue.Emp_Code : "");
                              }}
                              options={employeesList}
                              getOptionLabel={(emp) =>
                                emp?.EA_Rank ? `${emp.EA_Rank} ${emp.fullName}` : emp?.fullName || ""
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  color="secondary"
                                  variant="outlined"
                                  InputProps={{
                                    ...params.InputProps,
                                    sx: {
                                      height: "48px",
                                      fontSize: "14px",
                                    },
                                  }}
                                />
                              )}
                            />
                          </Box> */}
                        <FormControl fullWidth>
                          <Multiselect
                            options={employeesList}
                            selectedValues={selectedEmployees}
                            onSelect={(list) => setSelectedEmployees(list)}
                            onRemove={(list) => setSelectedEmployees(list)}
                            displayValue="displayLabel"
                            placeholder="Select Employees"
                            showCheckbox={true}
                            avoidHighlightFirstOption={true}
                            showArrow={true}
                            style={{
                              multiselectContainer: {
                                width: "100%",
                              },
                              chips: {
                                background: "#BF1D2D1A",
                              },
                              searchBox: {
                                fontSize: "14px",
                                height: "59px",
                              },
                            }}
                          />
                        </FormControl>
                        </Grid>
                      </Grid>
                    }
                  </>
                }

                {mode === 'template' &&
                  <>
                    <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
                      <Grid item xs={12} sm={12} md={6}>
                        <label style={{ fontSize: '14px' }}>Template <ReqComponent /></label>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
                      <Grid className='pt-4' item xs={6} sm={6} md={6}>
                        <TextField
                          className='w-100' color='secondary' variant="outlined"
                          select
                          value={chosenTemplate}
                          onChange={e => setChosenTemplate(e.target.value)}
                          InputProps={{
                            sx: {
                              height: '48px',
                              fontSize: '14px'
                            }
                          }}
                        >
                          {templateList.map(type => (
                            <MenuItem value={type.Duty_Crew_Code}>{type.Duty_Crew_Description} </MenuItem>
                          ))}

                        </TextField>
                      </Grid>
                    </Grid>

                    <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }} className='mt-1'>
                      <Grid item xs={12} sm={12} md={12}>
                        <label style={{ fontSize: '14px' }}>Vendor <ReqComponent /></label>
                      </Grid>
                      <Grid className='pt-2' item xs={6} sm={6} md={6}>
                        <TextField
                          className='w-100' color='secondary' variant="outlined"
                          select
                          value={chosenVendor}
                          onChange={e => setChosenVendor(e.target.value)}
                          InputProps={{
                            sx: {
                              height: '48px',
                              fontSize: '14px'
                            }
                          }}
                        >
                          {vendorList.map(vendor => (
                            <MenuItem value={vendor[0]}>{vendor[1]} </MenuItem>
                          ))}

                        </TextField>
                      </Grid>
                    </Grid>
                    <Grid container columns={{ xs: 12, sm: 12, md: 12 }} className='mt-3'>
                      <Grid item xs={12} sm={12} md={12} className='mb-2'>
                        <label style={{ fontSize: '14px' }}>Vendor Info</label>
                      </Grid>
                      <Textarea
                        value={vendorText}
                        onChange={e => setVendorText(e.target.value)}
                        placeholder='Enter vendor info'
                      />
                    </Grid>
                  </>
                }

                <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }} className='pt-5 px-2'>
                  <ButtonTheme disabled={saving || isErrorTime || !cansubmit || (isDuplicating && !duplicateDirty)} type='submit' variant="filled" color='primary' className='px-5 mx-2'>
                    {saving && 'Loading...'}
                    {!saving && 'Save'}
                  </ButtonTheme>
                  <ButtonTheme disabled={saving} onClick={() => isDuplicating ? closeDuplicate() : setIsAdding(false)} variant="filled" className='px-5'>
                    Cancel
                  </ButtonTheme>
                </Grid>
              </form>
          );
          return isDuplicating ? (
            <Dialog open onClose={closeDuplicate} maxWidth="lg" fullWidth scroll="paper">
              <DialogTitle className='d-flex justify-content-between align-items-center'>
                Duplicate Detail
                <IconButton onClick={closeDuplicate} size="small"><CloseIcon /></IconButton>
              </DialogTitle>
              <DialogContent dividers>
                {detailFormEl}
              </DialogContent>
            </Dialog>
          ) : (
            <Grid item xs={12}>
              <Typography variant='h6' className='d-flex align-items-center'>
                <div><ArrowBackIosIcon onClick={() => setIsAdding(false)} style={{ cursor: 'pointer' }} /> </div>
                Add {v3Data?.V3_ALLOW_ALTER_LABEL_TEXTS === 'true' ? 'CPP' : 'Detail'}
              </Typography>
              <Box className='py-2'>
                {detailFormEl}
              </Box>
            </Grid>
          );
        })()}

        {isEditing &&
          <Grid item xs={12}>
            <Typography variant='h6'>Edit {v3Data?.V3_ALLOW_ALTER_LABEL_TEXTS === 'true' ? 'CPP' : 'Detail'}</Typography>
            <Box>
              <form onSubmit={handleSubmitEdit}>
                <Grid container spacing={2} className='mt-2'>
                  <Grid item xs={12} sm={12} md={3}>
                    <label style={{ fontSize: '14px' }}>Date</label>
                    <Box className='mt-1'>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          value={dateEdit}
                          onChange={(e) => setDateEdit(e)}
                          sx={{
                            width: "100%",
                            "& .MuiInputBase-root": {
                              height: '48px',
                              fontSize: '14px'
                            },
                          }}
                          disablePast
                          dateInputIcon={<CalendarTodayIcon />}
                        />
                      </LocalizationProvider>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3}>
                    <label style={{ fontSize: '14px' }}>Shift</label>
                    <Box className='mt-1'>
                      <TextField
                        className='w-100' color='secondary' variant="outlined"
                        select
                        value={chosenShiftEdit}
                        onChange={e => setChosenShiftEdit(e.target.value)}
                        InputProps={{
                          sx: {
                            height: '48px',
                            fontSize: '14px'
                          }
                        }}
                      >
                        {shiftList.map(type => (
                          <MenuItem value={type.ShiftCode}>{type.Shift} </MenuItem>
                        ))}

                      </TextField>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3}>
                    {chosenShiftEdit === 0 && <label style={{ fontSize: '14px' }}>From</label>}
                    <Box className='mt-1'>
                      {chosenShiftEdit === 0 &&
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <TimePicker
                            timeSteps={{ minutes: 30 }}
                            value={startTimeEdit}
                            onChange={(newValue) => setStartTimeEdit(newValue)}
                            sx={{
                              "& .MuiOutlinedInput-input": { color: isErrorTimeEdit && 'red' },
                              width: "100%",
                              "& .MuiInputBase-root": {
                                height: '48px',
                                fontSize: '14px'
                              },
                            }}
                          />
                        </LocalizationProvider>
                      }
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3}>
                    {chosenShiftEdit === 0 && <label style={{ fontSize: '14px' }}>To</label>}
                    <Box className='mt-1'>
                      {chosenShiftEdit === 0 &&
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <TimePicker
                            timeSteps={{ minutes: 30 }}
                            value={endTimeEdit}
                            onChange={(newValue) => setEndTimeEdit(newValue)}
                            sx={{
                              "& .MuiOutlinedInput-input": { color: isErrorTimeEdit && 'red' },
                              width: "100%",
                              "& .MuiInputBase-root": {
                                height: '48px',
                                fontSize: '14px'
                              },
                            }}
                          />
                        </LocalizationProvider>
                      }
                    </Box>
                  </Grid>
                  {/* {isErrorTimeEdit &&
                    <div style={{ position: 'relative', left: '52.5%', color: 'red', fontSize: '.9rem' }}>
                      Error: "To" time must be after "From"
                    </div>
                  } */}
                </Grid>

                <Grid style={{display :'flex' , justifyContent :'flex-start' , alignItems :'center'}} container spacing={2} className='mt-3'>
                  <Grid item xs={12} sm={12} md={4}>
                    <label style={{ fontSize: '14px' }}>Overtime List</label>
                    <Box className='mt-1'>
                      <TextField
                        className='w-100' color='secondary' variant="outlined"
                        select
                        value={chosenOVEdit}
                        onChange={e => setChosenOVEdit(e.target.value)}
                        InputProps={{
                          sx: {
                            height: '48px',
                            fontSize: '14px'
                          }
                        }}
                      >
                        {ovTList.map(type => (
                          <MenuItem value={type.Overtime_List}>{type.Overtime_List_Description} </MenuItem>
                        ))}

                      </TextField>
                    </Box>
                  </Grid>
                  {/* {allowedVars?.V3_ADD_CHECKBOX_FOR_ADD_DETAIL && 
                  <Grid item xs={12} sm={12} md={4} >
                    <Box className='mt-4'>
                      <FormControlLabel
                      control={
                        <Checkbox
                          checked={doNotMarkHours}
                          onChange={(e) => setDoNotMarkHours(e.target.checked)}
                          color="primary"
                        />
                      }
                      label="Do not mark hours"
                    />
                    </Box>
                    
                  </Grid>} */}
                </Grid>

                <Grid container spacing={2} className='mt-3'>
                  <Grid item xs={12} sm={12} md={4}>
                    <div>
                      <label style={{ fontSize: '14px' }}>Details (What)</label>
                      <Box className='mt-1'>
                        <TextField
                          className='w-100' color='secondary' variant="outlined"
                          select
                          value={chosenDetailEdit}
                          onChange={e => setChosenDetailEdit(e.target.value)}
                          InputProps={{
                            sx: {
                              height: '48px',
                              fontSize: '14px'
                            }
                          }}
                        >
                          {detailsList.map(type => (
                            <MenuItem value={type.SO_Value}>{type.SO_Desc} </MenuItem>
                          ))}

                        </TextField>
                      </Box>
                    </div>
                    <div className='mt-4'>
                      <label style={{ fontSize: '14px' }}>Details Description</label>
                      <Box className='mt-1'>
                        <Textarea
                          value={detailsTextEdit}
                          onChange={e => setDetailsTextEdit(e.target.value)}
                          placeholder='Enter details description'
                          minRows={2}
                        />
                      </Box>
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12} md={4}>
                    <div>
                      <label style={{ fontSize: '14px' }}>Assignment (Where)</label>
                      <Box className='mt-1'>
                        <TextField
                          className='w-100' color='secondary' variant="outlined"
                          select
                          value={chosenAssignmentEdit}
                          onChange={e => setChosenAssignmentEdit(e.target.value)}
                          InputProps={{
                            sx: {
                              height: '48px',
                              fontSize: '14px'
                            }
                          }}
                        >
                          {assignmentList.map(type => (
                            <MenuItem value={type.SO_Value}>{type.SO_Desc} </MenuItem>
                          ))}

                        </TextField>
                      </Box>
                    </div>
                    <div className='mt-4'>
                      <label style={{ fontSize: '14px' }}>Assignment Description</label>
                      <Box className='mt-1'>
                        <Textarea
                          value={assignmentTextEdit}
                          onChange={e => setAssignmentTextEdit(e.target.value)}
                          placeholder='Enter assignment description'
                        />
                      </Box>
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12} md={4}>
                    <div>
                      <label style={{ fontSize: '14px' }}>Vendor</label>
                      <Box className='mt-1'>
                        <TextField
                          className='w-100' color='secondary' variant="outlined"
                          select
                          value={chosenVendorEdit}
                          onChange={e => setChosenVendorEdit(e.target.value)}
                          InputProps={{
                            sx: {
                              height: '48px',
                              fontSize: '14px'
                            }
                          }}
                        >
                          {vendorList.map(vendor => (
                            <MenuItem value={vendor[0]}>{vendor[1]} </MenuItem>
                          ))}

                        </TextField>
                      </Box>
                    </div>
                    <div className='mt-4'>
                      <label style={{ fontSize: '14px' }}>Vendor Info</label>
                      <Box className='mt-1'>
                        <Textarea
                          value={vendorTextEdit}
                          onChange={e => setVendorTextEdit(e.target.value)}
                          placeholder='Enter vendor info'
                        />
                      </Box>
                    </div>
                  </Grid>
                </Grid>

                <Grid item columns={{ xs: 12, sm: 12, md: 12 }} className='pt-3'>
                  <FormControl sx={{ flexDirection: 'row', gap: '16px', alignItems: 'center' }}>
                    <FormLabel className=" text-black " style={{ fontSize: '14px' }}>Fill Type</FormLabel>
                    <RadioGroup
                      value={fillMethodEdit}
                      onChange={(e) => setFillMethodEdit(e.target.value)}
                      name="radio-buttons-group"
                      row
                    >
                      <FormControlLabel value="auto" control={<Radio />} label="Auto" />
                      <FormControlLabel value="manual" control={<Radio />} label="Manual" />
                    </RadioGroup>
                    {origFillMethodEdit === 'manual' && fillMethodEdit === 'auto' && allowedVars?.V3_ALLOW_KEEP_DETAIL_OSL_HOURS === 'true' &&
                      <FormControlLabel
                        control={<Checkbox checked={keepHoursEdit} onChange={(e) => setKeepHoursEdit(e.target.checked)} />}
                        label="Keep Assigned Hours"
                      />
                    }
                  </FormControl>
                </Grid>

                {fillMethodEdit === 'auto' &&
                  <>
                    <Grid container spacing={2} className='pt-2'>
                      <Grid item xs={12} sm={12} md={3}>
                        <label style={{ fontSize: '14px' }}>Rank <ReqComponent /></label>
                        <Box className='mt-1'>
                          <TextField
                            className='w-100' color='secondary' variant="outlined"
                            select
                            value={chosenRankEdit}
                            onChange={e => setChosenRankEdit(e.target.value)}
                            InputProps={{
                              sx: {
                                height: '48px',
                                fontSize: '14px'
                              }
                            }}
                          >
                            {rankList.map(r => (
                              <MenuItem value={r[0]}>{r[1]} </MenuItem>
                            ))}
                          </TextField>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={12} md={3}>
                        <label style={{ fontSize: '14px' }}>EMT <ReqComponent /></label>
                        <Box className='mt-1'>
                          <TextField
                            className='w-100' color='secondary' variant="outlined"
                            select
                            value={chosenEMTEdit}
                            onChange={e => setChosenEMTEdit(e.target.value)}
                            InputProps={{
                              sx: {
                                height: '48px',
                                fontSize: '14px'
                              }
                            }}
                          >
                            {EMTList.map(e => (
                              <MenuItem value={e[0]}>{e[1]} </MenuItem>
                            ))}
                          </TextField>
                        </Box>
                      </Grid>
                    </Grid>
                  </>
                }

                {fillMethodEdit === 'manual' &&
                  <Grid container spacing={2} className='pt-2'>
                    <Grid item xs={12} sm={12} md={3}>
                      <label style={{ fontSize: '14px' }}>Employees <ReqComponent /></label>
                      <Box className='mt-1'>
                        <TextField
                          className='w-100' color='secondary' variant="outlined"
                          select
                          SelectProps={{
                            multiple: false,
                          }}
                          value={chosenEmployeeEdit}
                          onChange={e => setChosenEmployeeEdit([e.target.value])}
                          InputProps={{
                            sx: {
                              height: '48px',
                              fontSize: '14px'
                            }
                          }}
                        >
                          {employeesList.map(emp => (
                            <MenuItem value={emp.Emp_Code}>{emp.EA_Rank ? `${emp.EA_Rank} ${emp.fullName}` : emp.fullName} </MenuItem>
                          ))}
                        </TextField>
                      </Box>
                    </Grid>
                  </Grid>
                }

                <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }} className='pt-5 px-2'>
                  <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
                    <ButtonTheme disabled={saving || isErrorTimeEdit} type='submit' variant="filled" color='primary' className='px-5 mx-4'>
                      {saving && 'Loading...'}
                      {!saving && 'Save'}
                    </ButtonTheme>
                    <ButtonTheme disabled={saving} onClick={() => { setIsEditing(false); setKeepHoursEdit(defaultKeepHours); }} variant="filled" className='px-5'>
                      Cancel
                    </ButtonTheme>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Grid>
        }

        {!isAdding && !isEditing &&
          <Grid item xs={12}>
            <Row>
              <Col md={6} sm={3} xs={3}>
                <Typography variant='h5'>{v3Data?.V3_ALLOW_ALTER_LABEL_TEXTS === 'true' ? 'CPP' : 'Details'}</Typography>
              </Col>
              <Col md={6} sm={8} xs={8}>
                <Grid container sx={{ display: 'flex', gap: '0.625rem', justifyContent: 'flex-end' }}>
                  <ButtonTheme color='primary' onClick={() => setIsAdding(true)} disabled={loading}>
                    Add
                  </ButtonTheme>
                  <ButtonTheme color='primary' onClick={() => setIsEditing(true)} disabled={SelectedEmp.length !== 1}>
                    Edit
                  </ButtonTheme>
                  <ButtonTheme color='primary' onClick={handleDeleteClick} disabled={SelectedEmp.length === 0 || saving}>
                    Delete
                  </ButtonTheme>
                </Grid>
              </Col>
            </Row>
            <div style={{ padding: '0!important', margin: '1rem 0' }}>
              <Box sx={{ maxWidth: '90vw', background: '#FFF', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                <Row>
                  <Col md={9} sm={10} xs={10} style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ width: '200px' }} className={activeTab == 'upcoming' ? 'tab-active' : 'tab-white'}
                      onClick={() => setActiveTab('upcoming')}>
                      Upcoming {v3Data?.V3_ALLOW_ALTER_LABEL_TEXTS === 'true' ? 'CPP' : 'Details'} ({rows?.data?.length})
                    </div>
                    <div style={{ width: '190px' }} className={activeTab == 'history' ? 'tab-active mx-2' : 'tab-white mx-2'}
                      onClick={() => setActiveTab('history')}>
                      {v3Data?.V3_ALLOW_ALTER_LABEL_TEXTS === 'true' ? 'CPP' : 'Details'} History ({historyRows?.data?.length})
                    </div>
                  </Col>
                  <Col md={3} sm={2} xs={2} className="d-flex justify-content-end">
                    <Box
                      component="img"
                      src={anyExpanded ? '/images/collapse.svg' : '/images/expand.svg'}
                      alt="Icon"
                      onClick={toggleAllCollapses}
                      style={{ cursor: 'pointer', width: '22px', height: '22px', marginTop: '18px', marginRight: '10px' }}
                    />
                  </Col>
                </Row>
                {loading &&
                  <Box className="w-100 d-flex justify-content-center align-items-center"
                    style={{ height: '430px' }}>
                    <CircularProgress />
                  </Box>
                }
                {activeTab == 'upcoming' &&
                  <>
                    {!loading &&
                      <div>
                        <p>Upcoming {v3Data?.V3_ALLOW_ALTER_LABEL_TEXTS === 'true' ? 'CPP' : 'Details'}</p>
                        <div className="hide-header-checkbox-page">
                          {rows && rows.data && rows.data.length > 0 && dates.map((d) =>
                            <FilterRows key={d}
                              rowSelectionModel={SelectedEmp}
                              onRowSelectionModelChange={onRowSelectionModelChange}
                              columns={columns}
                              rows={rows}
                              open={expandAll}
                              onExpandChange={handleExpandChange}
                              date={d}
                              allowedVars={allowedVars}
                            />)}
                        </div>
                        <br />
                        {rows.data.length > 0 &&
                          <PaginationComponent
                            results={rows}
                            pageChanged={PageChanged}
                          />
                        }
                      </div>
                    }
                    {!loading && rows.data.length === 0 &&
                      <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 400 }}>
                        <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                        <span className='mt-4' style={{ color: '#555555' }}>
                          No {v3Data?.V3_ALLOW_ALTER_LABEL_TEXTS === 'true' ? 'CPP' : 'Details'} Found
                        </span>
                      </div>
                    }
                  </>
                }


                {!loading && Hloading &&
                  <Box className="w-100 d-flex justify-content-center align-items-center"
                    style={{ height: '400px' }}>
                    <CircularProgress />
                  </Box>
                }
                {activeTab == 'history' &&
                  <>
                    {!Hloading &&
                      <div>
                        <p className='mb-3'>{v3Data?.V3_ALLOW_ALTER_LABEL_TEXTS === 'true' ? 'CPP' : 'Details'} History</p>
                        <div className="hide-header-checkbox-page">
                        {historyRows && historyRows.data && historyRows.data.length > 0 && historyDates.map((d) =>
                          <FilterRows
                            allowedVars={allowedVars}
                            isHistory={true}
                            rowSelectionModel={SelectedEmp}
                            onRowSelectionModelChange={onRowSelectionModelChange}
                            key={d}
                            columns={columns}
                            rows={historyRows}
                            open={expandAll}
                            onExpandChange={handleExpandChange}
                            date={d} />)}
                        </div>
                        <br />
                        {historyRows.data.length > 0 &&
                          <PaginationComponent
                            results={historyRows}
                            pageChanged={PageChangedHistory}
                          />
                        }
                      </div>
                    }
                    {!Hloading && historyRows.data.length === 0 &&
                      <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 400 }}>
                        <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                        <span className='mt-4' style={{ color: '#555555' }}>
                          No {v3Data?.V3_ALLOW_ALTER_LABEL_TEXTS === 'true' ? 'CPP' : 'Details'} History Found
                        </span>
                      </div>
                    }
                  </>
                }
              </Box>

            </div>
          </Grid>
        }
      </Grid>

      {/* Delete confirmation with Keep Hours option */}
      <Dialog open={deleteModal} onClose={() => !saving && setDeleteModal(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 700 }}>Delete Details</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 1, color: '#555555' }}>
            Are you sure you want to delete the selected detail shift(s)?
          </Typography>
          <FormControlLabel
            control={<Checkbox checked={keepHours} onChange={(e) => setKeepHours(e.target.checked)} />}
            label="Keep hours"
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', mt: 2 }}>
            <ButtonTheme color='secondary' onClick={() => setDeleteModal(false)} disabled={saving}>
              Cancel
            </ButtonTheme>
            <ButtonTheme color='primary' onClick={deleteShifts} disabled={saving}>
              Delete
            </ButtonTheme>
          </Box>
        </DialogContent>
      </Dialog>
    </Paper>
  </>);
}
